<template>
  <div class="products-container m-auto pb-2">
    
    <div>
      <img
        :src="
          imgUrl(
            $template.products_shop_picture,
            'campaign_product_shop_personnalisation'
          )
        "
        alt=""
        class="w-full pb-0 lg:pb-4 p-2"
      />
      <div class="flex flex-wrap lg:mt-4 justify-evenly" :class="$template.enseigne ? '' :''">
        <div
          v-for="product in products"
          :key="product.id"
          class="bg-white my-1 md:my-4 lg:w-[31%] w-[46%] flex flex-col"
        >
          <div
            class="relative"
            :style="getBg(product)"
            style="
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              aspect-ratio: 1.4/1;
            "
          >
            <div v-if="product.promotion_title || product.promotion_subtitle">
              <p class="reduction !text-xs md:!text-xl" :style="setCartbridgePromotion($template)">
                {{ product.promotion_title }} <br />
                <span class="text-sm">{{ product.promotion_subtitle }}</span>
              </p>
            </div>
          </div>
          <div class="flex flex-col justify-between px-4 grow">
            <div>
              <p class="text-red font-bold text-sm md:text-xl">{{ product.name }}</p>

              <div class="flex justify-between">
                <div>
                  <div class="text-xs md:text-sm" v-html="tagText(product.content)"></div>
                  <div
                    class="text-xs md:text-sm"
                    v-html="tagText(product.quantity_title)"
                  ></div>
                </div>
                <div>
                  <div v-if="product.reduced_price">
                    <p class="text-red font-bold text-sm md:text-2xl text-right">
                      {{ product.reduced_price.toFixed(2) }}€
                    </p>
                    <p class="line-through text-right text-xs md:text-base">
                      {{ product.crossed_price.toFixed(2) }}€
                    </p>
                  </div>
                  <div v-else>
                    <p class="text-red font-bold text-sm md:text-2xl text-right">
                      {{ product.crossed_price.toFixed(2) }}€
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="md:flex my-4 justify-between">
              <div class="flex items-center">
                <p class="mr-2 text-xs md:text-base">Quantité</p>
                <div class="lg:w-1/6 mr-2">
                  <Field
                    :id="'quantity-' + product.id"
                    class="selectForm !w-fit"
                    :name="'quantity'"
                    as="select"
                    value="1"
                  >
                    <option
                      v-for="option in product.quantity_max"
                      :key="option"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </Field>
                </div>
              </div>
              <button
                class="button-product flex uppercase mt-2 md:mt-0"
                @click="addProduct(product)"
              >
                  <img src="@/assets/img/play.png" alt="" class="w-3 md:w-4 m-auto" />
                  <p class="ml-2 text-[10px] lg:text-sm my-auto">{{ $template.products_button }}</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Field } from 'vee-validate'

export default {
  components: {
    Field
  },
  emits: ['addToCart'],
  computed: {
    products() {
      return this.$store.products
    },
    isWinner() {
      return this.$store.isWheelWinner && this.$template.campaign_template_mechanic_id === 5
    }
  },
  methods: {
    getBg(product) {
      return (
        "background-image: url('" +
        this.imgUrl(product.illustration, 'products_illustration') +
        "')"
      )
    },
    setCartbridgePromotion(template) {
      return (
        'background-color: ' +
        template.cartridge_promotion_background_color +
        '; color: ' +
        template.cartridge_promotion_text_color
      )
    },
    addProduct(product) {
      let quantity = document.getElementById('quantity-' + product.id)
      this.$emit('addToCart', { id: product.id, quantity: quantity.value })
    }
  },
}
</script>

<style scoped>
.button-product {
  background-color: v-bind(
    "$template ? $template.products_button_background_color : ' '"
  );
  color: v-bind("$template ? $template.products_button_text_color : ' '");
}

.products-container {
  background-color: v-bind(
    "$template ? $template.products_background_color : ' '"
  );
}

.div-form {
  @apply lg:flex  w-full mt-3;
}

.input-form {
  @apply lg:w-1/2 lg:mr-4 mt-3 lg:mt-0;
}
</style>
